import { action } from 'typesafe-actions';
import { IFabricationContract } from '../fabrication-contracts/types';
import { ECustomerTypeView } from '../user/types';
import { IConstructionRegistrationState } from './types';
import { Types } from './types';

export const updateConstructionRegistrationSettings = (
  constructionRegistration: IConstructionRegistrationState
) =>
  action(Types.UPDATE_CONTRUCTION_REGISTRATION_SETTINGS, {
    constructionRegistration
  });

export const sendConstructionRegistration = (
  constructionRegistration: IConstructionRegistrationState,
  selectedCustomerId: string,
  customerViewType: ECustomerTypeView
) =>
  action(Types.FINISH_CONSTRUCTION_REGISTRATION, {
    constructionRegistration,
    selectedCustomerId,
    customerViewType
  });

export const sendConstructionRegistrationV2 = (
  constructionRegistration: IConstructionRegistrationState,
  selectedCustomerId: string
) =>
  action(Types.FINISH_CONSTRUCTION_REGISTRATION, {
    constructionRegistration,
    selectedCustomerId
  });
export const sendConstructionRegistrationSuccess = () =>
  action(Types.FINISH_CONSTRUCTION_REGISTRATION_SUCCESS, {});
export const sendConstructionRegistrationFailure = (err: unknown) =>
  action(Types.FINISH_CONSTRUCTION_REGISTRATION_FAILURE, { err });

export const loadCustomerContracts = (
  selectedCustomerId: string,
  customerViewType: ECustomerTypeView,
  needToLoadCustomer?: boolean
) =>
  action(Types.LOAD_CUSTOMER_CONTRACTS, {
    selectedCustomerId,
    customerViewType,
    needToLoadCustomer
  });

export const loadCustomerContractsV2 = (
  selectedCustomerId: string,
  needToLoadCustomer?: boolean
) =>
  action(Types.LOAD_CUSTOMER_CONTRACTS_V2, {
    selectedCustomerId,
    needToLoadCustomer
  });

export const loadCustomerContractsSuccess = (
  customerContracts: IFabricationContract[]
) => action(Types.LOAD_CUSTOMER_CONTRACTS_SUCCESS, { customerContracts });
export const loadCustomerContractsFailure = (err: unknown, bpError?: boolean) =>
  action(Types.LOAD_CUSTOMER_CONTRACTS_FAILURE, { err, bpError });

export const setHighlightNewContracts = (highlightNewContracts: boolean) =>
  action(Types.SET_HIGHLIGHT_NEW_CONTRACTS, { highlightNewContracts });

export const clearConstructionRegistrationSettings = () =>
  action(Types.CLEAR_CONTRUCTION_REGISTRATION_SETTINGS);

export const clearContractsAndConstructionsState = () =>
  action(Types.CLEAR_CONTRACTS_AND_CONSTRUCTIONS_STATE);

export const openNewConstructionModal = () =>
  action(Types.OPEN_NEW_CONSTRUCTION_MODAL);

export const closeNewConstructionModal = () =>
  action(Types.CLOSE_NEW_CONSTRUCTION_MODAL);
